// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"171":"collection","233":"three","354":"community","644":"account","841":"studio"}[chunkId] || chunkId) + "." + {"171":"c94906ce","233":"59f302ac","354":"f5e2e7b1","515":"2d26c019","644":"516fa648","841":"36100e69","896":"edd229ac"}[chunkId] + ".js";
};